// Derive the human-facing status page URL for a provider.
//
// Precedence:
//   1. provider.dashboard_url, if set, wins. This is the explicit override
//      for cases where origin-stripping doesn't yield the dashboard (e.g.
//      Google Workspace polls google.com/appsstatus/dashboard/incidents.json
//      — origin-strip returns google.com homepage, which is wrong).
//   2. Otherwise, origin-strip source_url. Most Atlassian-style providers
//      serve their dashboard at the same origin as the JSON we poll
//      (status.cloudflare.com/api/v2/status.json -> status.cloudflare.com).
//   3. If source_url isn't parseable, return it raw as a last resort.
//
// The legacy string-only form is kept as a thin wrapper for call sites that
// don't have the full provider object on hand (none currently in tree, but
// the test fixtures use it).
export function statusPageUrlFromString(sourceUrl: string): string {
  try {
    const u = new URL(sourceUrl);
    return `${u.protocol}//${u.host}`;
  } catch {
    return sourceUrl;
  }
}

interface UrlSource {
  source_url: string;
  dashboard_url?: string | null;
}

export function statusPageUrl(input: string | UrlSource): string {
  if (typeof input === 'string') return statusPageUrlFromString(input);
  if (input.dashboard_url) return input.dashboard_url;
  return statusPageUrlFromString(input.source_url);
}
